import React, { forwardRef } from 'react';

// eslint-disable-next-line react/display-name
const StripedTableHead = forwardRef(
    ({ id = 'striped-table-head', ...props }, ref) => {
        return (
            <thead
                {...props}
                id={id}
                ref={ref}
                style={{
                    boxSizing: 'border-box',
                    backgroundColor: 'rgb(255,255,255)',
                    fontWeight: 500,
                    color: 'rgb(65,65,65)',
                    textAlign: 'center',
                    fontSize: 15,
                    position: 'relative',
                    zIndex: 500,
                    ...props.style
                }}
            />
        );
    }
);

export default StripedTableHead;
